/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast. Keeping your custom
 * Javascript in this file will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function() {
  // Add custom code below this line
  

  // Trocar texto espanhol no carrinho dinamarquês (cart drawer + /cart)
  document.addEventListener('DOMContentLoaded', () => {
    const oldText = 'ENVÍO GRATUITO - 30 DÍAS DE DEVOLUCIÓN';
    const newText = 'Livraison gratuite - politique de retour de 30 jours';

    function replaceText(root) {
      if (!root) return;

      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      let node;

      while ((node = walker.nextNode())) {
        if (node.nodeValue && node.nodeValue.includes(oldText)) {
          node.nodeValue = node.nodeValue.replace(oldText, newText);
        }
      }
    }

    // tentativa inicial
    replaceText(document.body);

    // volta a tentar quando o carrinho abre/atualiza via AJAX
    const obs = new MutationObserver(() => replaceText(document.body));
    obs.observe(document.body, { childList: true, subtree: true });
  });

  // ^^^ Keep your scripts inside this IIFE function call to avoid leaking
  // your variables into the global scope.
// FIX: trocar "ENVÍO GRATUITO - 30 DÍAS DE DEVOLUCIÓN" para dinamarquês
  document.addEventListener('DOMContentLoaded', () => {
    const replacements = [
      { from: 'ENVÍO GRATUITO - 30 DÍAS DE DEVOLUCIÓN', to: 'Gratis levering – 30 dages returret' },
      { from: 'ENVÍO GRATUITO – 30 DÍAS DE DEVOLUCIÓN', to: 'Gratis levering – 30 dages returret' }
    ];

    function run() {
      const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
      let node;

      while ((node = walker.nextNode())) {
        if (!node.nodeValue) continue;

        for (const r of replacements) {
          if (node.nodeValue.includes(r.from)) {
            node.nodeValue = node.nodeValue.replaceAll(r.from, r.to);
          }
        }
      }
    }

    run();

    // cart drawer / ajax updates
    const obs = new MutationObserver(run);
    obs.observe(document.body, { childList: true, subtree: true });
  });
  /* ===== Corrigir texto do badge: "60% SPAR/RABAT" -> "SPAR 60%" ===== */
function fixSparBadges(root = document) {
  const nodes = root.querySelectorAll('.badge, .badge--sale, .product__badge, .product__badge--sale');
  nodes.forEach(el => {
    const t = (el.textContent || '').trim();

    // 60% SPAR  |  60% RABAT  -> SPAR 60%
    let m = t.match(/^(\d+)\s*%\s*(SAUVEGARDER|RABAIS)$/i);
    if (m) {
      el.textContent = `SAUVEGARDER ${m[1]}%`;
      return;
    }

    // caso venha com espaços/variações: "60 % SPAR"
    m = t.match(/^(\d+)\s*%?\s*(SAUVEGARDER|RABAIS)$/i);
    if (m && t.includes('%')) {
      el.textContent = `SAUVEGARDER ${m[1]}%`;
      return;
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  fixSparBadges(document);

  // re-aplicar quando AJAX/carregamentos atualizam a página
  const obs = new MutationObserver(() => fixSparBadges(document));
  obs.observe(document.body, { childList: true, subtree: true });
});

})();
